import {
  VariantOptionSelect as OptionSelect,
  VariantOptionValues as OptionValues,
  VariantSelectedVariant as SelectedVariant,
  VariantSelector as Selector,
} from "./variant-selector.components";

/**
 * Usage:
 * ```tsx
 * <VariantSelector.Selector product={product}>
 * <VariantSelector.OptionSelect type="color">
 *     {({ attribute, selected }) => (
 *     <VariantSelector.OptionValues>
 *         {({ option, selectedValue, setSelected }) => null}
 *     </VariantSelector.OptionValues>
 *     )}
 * </VariantSelector.OptionSelect>
 * ..... other selectors
 * <VariantSelector.SelectedVariant>
 *    // variant will be undefined until all options are selected
 *    {({ salePrice, currentPrice, variant }) => null}
 * </VariantSelector.SelectedVariant>
 * </VariantSelector.Selector>
 *```
 */
export const VariantSelector = {
  Selector,
  /** Renders children only if option exist */
  OptionSelect,
  OptionValues,
  SelectedVariant,
};
